import React from 'react';
import { cn } from '../../lib/utils';
import { getState, TASK_STATE_META } from '../../design-system/states';

/**
 * OrkaStatePill — canonical task-state display (PRD §6.4, Rule 3).
 *
 * Replaces every `.status-*` utility, the `statusColors` map duplicated
 * across BacklogPane / TaskCard / ScheduledPane, and the `Badge` shadcn
 * wrapper used inline for task status.
 *
 *   <OrkaStatePill state="In Progress" />
 *   <OrkaStatePill state="partial" outline />
 */
export function OrkaStatePill({ state, size = 'md', outline = false, className, ...rest }) {
  const meta = TASK_STATE_META[state] || getState(state);
  const SIZE = {
    sm: 'text-[10px] h-5 px-1.5',
    md: 'text-xs h-6 px-2',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center font-semibold rounded-full select-none gap-1',
        SIZE[size] || SIZE.md,
        outline ? 'border bg-transparent' : '',
        className,
      )}
      style={{
        backgroundColor: outline ? 'transparent' : meta.soft,
        color: meta.text,
        borderColor: outline ? meta.border : undefined,
      }}
      data-state={meta.key}
      {...rest}
    >
      <span
        className="w-1.5 h-1.5 rounded-full shrink-0"
        style={{ backgroundColor: meta.color }}
        aria-hidden="true"
      />
      {meta.short}
    </span>
  );
}

export default OrkaStatePill;
